import React, { useState } from 'react';
import PropTypes from 'prop-types';
import DefaultButton from 'components/Utils/NewDefaultButton';
import SendFax from 'components/Misc/SendFax';
import Icon from 'components/Utils/NewIcon';
import DocumentPreview from 'components/Utils/DocumentPreview';
import './style.scss';
import { useAppSelector } from 'careand-redux/store';

const PreviewDocumentModal = ({
  showFax = true,
  button,
  patient,
  title,
  faxOptions = {},
  type,
  url,
  fax,
  onClose,
}) => {
  const [showFaxModal, setShowFaxModal] = useState(false);
  const authentication = useAppSelector((state) => state.authentication);

  function openFaxModal() {
    setShowFaxModal(true);
  }

  function closeFaxModal() {
    setShowFaxModal(false);
  }

  return (
    !!url && (
      <div className="modal preview-document-modal">
        {patient && showFaxModal ? (
          <SendFax
            fax={fax}
            onClose={closeFaxModal}
            url={url}
            patient={patient}
            title={title}
            {...(faxOptions || {})}
          />
        ) : null}
        {!!onClose && <Icon src="xmark" className="close-icon" onClick={onClose} />}
        <div className="title">Document Preview</div>
        <div className="content padded">
          <DocumentPreview url={url} type={type} />
          <div className="buttons">
            {button ||
              (showFax && (
                <DefaultButtons
                  patient={patient}
                  title={title}
                  authentication={authentication}
                  openFaxModal={openFaxModal}
                />
              ))}
          </div>
        </div>
      </div>
    )
  );
};

const DefaultButtons = React.memo(
  ({ patient, title, authentication, openFaxModal, showFax = true }) => {
    const hide = !patient || !title || authentication.role === 'patient';
    return (
      <div className="buttons">
        <div className="button">
          {!!patient && showFax && (
            <DefaultButton hide={hide} name="Send By Fax" onClick={openFaxModal} />
          )}
        </div>
      </div>
    );
  },
);

PreviewDocumentModal.propTypes = {
  url: PropTypes.string,
  patient: PropTypes.object,
  title: PropTypes.string,
  button: PropTypes.element,
  type: PropTypes.string,
  style: PropTypes.object,
  onClose: PropTypes.func,
  showFax: PropTypes.bool,
  sideBar: PropTypes.element,
  faxOptions: PropTypes.object,
};

export default PreviewDocumentModal;
